@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in" class="flex flex-col w-full justify-between">
      <div class="flex flex-row items-center w-full">
        @if (field.browserOpts.inLineWithCaption) {
          <mat-label class="mr-2 mb-4 font-medium">
            {{ field.label | localize }}
          </mat-label>
        }
        <mat-form-field class="w-full">
          @if (!field.browserOpts.inLineWithCaption) {
            <mat-label>
              {{ field.label | localize }}
            </mat-label>
          }
          <!-- <mat-icon matPrefix [ngStyle]="field.control.valid ? { color: field.control.value } : {}"
          svgIcon="mat_{{ field.control.value === '' ? 'outline' : 'solid' }}:{{ field.control.valid ? 'circle' : 'highlight_off' }}">
        </mat-icon> -->
        <!-- <input matInput [readonly]="true" [colorPicker]="field.control.value" [formControl]="field.control" [required]="field.required"
        [value]="field.control.value" [cpEyeDropper]="true" cpOKButtonText="OK" [cpOKButton]="true"
        [cpSaveClickOutside]="true" cpCancelButtonText="Cancelar" [cpCancelButton]="true" [cpPosition]="'bottom'" [cpAlphaChannel]="forced"
        cpOKButtonClass="mat-focus-indicator mat-button mat-button-base mat-flat-button mat-primary"
        cpCancelButtonClass="mat-focus-indicator mat-button mat-button-base mat-stroked-button mat-basic"
        cpOutputFormat="hex" cpAlphaChannel="always"
        (colorPickerChange)="field.control.setValue($event)" /> -->
        <input matInput type="color" [formControl]="field.control" [required]="field.required" />
        @if (field.hint) {
          <mat-hint>{{ field.hint | localize }}</mat-hint>
        }
        @if (field.control.hasError('required') && !field.readonly) {
          <mat-error>
            {{ 'errorRequiredField' | transloco }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>
}
} @else {
  <mat-icon [ngStyle]="field.control.valid ? { color: field.control.value } : {}"
    svgIcon="mat_{{ field.control.value === '' ? 'outline' : 'solid' }}:{{ field.control.valid ? 'circle' : 'highlight_off' }}">
  </mat-icon>
  {{ field.control.value }}
}

